import { defineCopy } from "@tami/core/intl";

import { WEB_SHELL_COPY_EN_US } from "./en-us/web-shell.copy";
import { WEB_SHELL_COPY_ES_ES } from "./es-es/web-shell.copy";

/** Textos só-web de componentes transversais (rodapé, cookies, bio, avisos, esqueletos). */
export const WEB_SHELL_COPY_PT_BR = {
  footer: {
    logoAlt: "Logo Tãmi",
    tagline: "Você cria. Tãmi organiza.",
    rights: "Tãmi. Todos os direitos reservados.",
    supportWhatsApp: (phone: string): string => `Suporte via WhatsApp: ${phone}`,
  },
  cookies: {
    before:
      "Usamos cookies e gravação de sessão para entender como o app é usado e melhorar a Tãmi. Não vendemos seus dados nem usamos para anúncios. Se recusar, paramos de medir e de gravar.",
    privacyLink: "Política de privacidade",
    accept: "Aceitar",
    decline: "Recusar",
    close: "Fechar",
  },
  bioSite: {
    logoAlt: "Tãmi",
    socialNavAria: "Redes sociais da Tãmi",
    featuresNavAria: "Funcionalidades",
    linksNavAria: "Links principais",
    whatsapp: "WhatsApp",
    email: "E-mail",
  },
  legalDocument: {
    updatedAt: "Última atualização em",
    taxId: "CNPJ",
  },
  hideValues: {
    show: "Mostrar valores",
    hide: "Ocultar valores",
  },
  sponsoredBilling: {
    before: "Assinatura custeada por",
    after: ". Para mudar de plano ou pagamento, fale com a Collab.",
  },
  sessionRevoke: {
    sessionIn: "A sessão em",
    afterSession: "será encerrada e precisará fazer login novamente.",
  },
  modal: {
    close: "Fechar modal",
  },
  floatingRefresh: {
    aria: "Recarregar página",
  },
  loading: {
    page: "Carregando página",
    navigation: "Carregando navegação",
  },
  mainNavigationAria: "Navegação principal",
  allPlatforms: "Todas plataformas",
} as const;

export const WEB_SHELL_COPY = defineCopy(WEB_SHELL_COPY_PT_BR, {
  "en-US": WEB_SHELL_COPY_EN_US,
  "es-ES": WEB_SHELL_COPY_ES_ES,
});
